import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const RulesContext = createContext();

export function RulesProvider({ caseID, children }) {
    const [histogramData, setHistogramData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);



    const loadHistogramData = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(`/api/percentiles/from/case/${caseID}`);
            if (response.status !== 200) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const processedData = processHistogramData(response.data);
            setHistogramData(processedData);
            setError(null);
        } catch (err) {
            console.error('Error loading histogram data:', err);
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadHistogramData();
        // eslint-disable-next-line
    }, [caseID]);

    const processHistogramData = (rawData) => {
        const processed = {};

        if (rawData.length > 0) {
            // Get all unique students first
            const allStudents = rawData.map(submission => submission.studentNumber);

            rawData.forEach(submission => {
                submission.percentiles.forEach(percentile => {
                    const organKey = `${percentile.a}_${percentile.b}`;

                    if (!processed[organKey]) {
                        // Initialize with data structure for all students
                        processed[organKey] = {
                            data: Array(101).fill().map((_, i) => {
                                const row = [i];  // Percentile
                                allStudents.forEach(() => row.push(null)); // Add placeholder for each student
                                return row;
                            }),
                            // Add 'Percentile' as first label followed by student numbers
                            labels: ['Percentile', ...allStudents],
                            organGS: percentile.a,
                            organST: percentile.b
                        };
                    }

                    // Find student index in labels array (offset by 1 due to 'Percentile' label)
                    const studentIndex = processed[organKey].labels.indexOf(submission.studentNumber);
                    if (studentIndex !== -1) {
                        // Add percentile data at the correct student column
                        processed[organKey].data[percentile.p][studentIndex] = percentile.vAbs;
                    }
                });
            });

            // Fill in gaps with previous values
            Object.values(processed).forEach(organData => {
                // For each student column
                for (let col = 1; col < organData.data[0].length; col++) {
                    let lastValidValue = null;
                    // For each percentile row
                    for (let row = 0; row < organData.data.length; row++) {
                        if (organData.data[row][col] === null) {
                            organData.data[row][col] = lastValidValue;
                        } else {
                            lastValidValue = organData.data[row][col];
                        }
                    }
                }
            });
        }
        return processed;
    };

    const getHistogramForOrgans = (organGS, organST) => {
        const key = `${organGS}_${organST}`;
        return histogramData[key] ;
        //|| {
        //             data: Array(101).fill().map((_, i) => [[i, null]]),
        //             labels: ['Percentile'], // Default label if no data
        //             organGS,
        //             organST
        //         };
    };

    const value = {
        histogramData,
        isLoading,
        error,
        getHistogramForOrgans,
        refreshHistogramData: loadHistogramData
    };

    return (
        <RulesContext.Provider value={value}>
            {children}
        </RulesContext.Provider>
    );
}

export function useHistogram() {
    const context = useContext(RulesContext);
    if (!context) {
        throw new Error('useHistogram must be used within a RulesProvider');
    }
    return context;
}